/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Include3_SubInputs */

const es_landing_price_include3_sub = /** @type {(inputs: Landing_Price_Include3_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobros seguros; tú recibes tu parte en tu cuenta`)
};

const gl_landing_price_include3_sub = /** @type {(inputs: Landing_Price_Include3_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobros seguros; ti recibes a túa parte na túa conta`)
};

const en_landing_price_include3_sub = /** @type {(inputs: Landing_Price_Include3_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure payments; you receive your share in your account`)
};

/**
* | output |
* | --- |
* | "Secure payments; you receive your share in your account" |
*
* @param {Landing_Price_Include3_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_include3_sub = /** @type {((inputs?: Landing_Price_Include3_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Include3_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_include3_sub(inputs)
	if (locale === "en") return en_landing_price_include3_sub(inputs)
	return es_landing_price_include3_sub(inputs)
});